module.exports = __webpack_public_path__ + "img/training-pic6.c46d5e1b.png";